import React from 'react';
import { Link } from 'react-router-dom';

// Import translation
import i18n from 'i18next';

export const createColumns = (handleSelectItem, isReadOnly) => [
	{
		Header: i18n.t('ingester:video_assets_params.table_columns.provider_id'),
		accessor: 'provider_id'
	},
	{
		Header: i18n.t('ingester:video_assets_params.table_columns.os'),
		accessor: 'os'
	},
	{
		Header: i18n.t('ingester:video_assets_params.table_columns.os_version'),
		accessor: 'os_version'
	},
	{
		Header: i18n.t('ingester:video_assets_params.table_columns.operator'),
		accessor: 'operator',
		sortable: false,
		width: 80
	},
	{
		Header: i18n.t('ingester:video_assets_params.table_columns.max_bitrate'),
		accessor: 'max_bitrate'
	},
	{
		Header: i18n.t('ingester:video_assets_params.table_columns.min_bitrate'),
		accessor: 'min_bitrate'
	},
	{
		Header: i18n.t('ingester:video_assets_params.table_columns.edit'),
		width: 80,
		className: 'text-center',
		sortable: false,
		Cell: ({
			row: {
				_original: { id }
			}
		}) =>
			!isReadOnly && (
				<Link
					to={`/panel/ingester/video-assets-params/edit/${id}`}
					className="btn btn-xs btn-primary"
				>
					<i className="fa fa-gear" />
				</Link>
			)
	},
	{
		Header: i18n.t('common:table_columns.delete'),
		accessor: 'delete',
		width: 60,
		className: 'text-center',
		sortable: false,
		Cell: ({
			row: {
				_original: { id }
			}
		}) =>
			!isReadOnly && (
				<button
					onClick={() => handleSelectItem(id)}
					className="btn btn-xs btn-primary"
				>
					<i className="fa fa-trash" />
				</button>
			)
	}
];
